module.exports = __webpack_public_path__ + "static/media/gonzonghao.01bca387.png";